module.exports = __webpack_public_path__ + "static/media/trezor.8ec6d85f.svg";